import { checkinApi } from '@/services/api/httpClient';

const admissionQuestionsActions = {
  async getAdmissionQuestionsById({ state, commit }) {
    const admissionId = state.data.id;
    const url = `/admission/questions/${admissionId}`;
    try {
      const getAdmissionQuestions = await checkinApi().get(url);

      const questions = getAdmissionQuestions.data;

      if (questions.length) {
        await commit('SET_ADMISSION_QUESTIONS', questions);
      }

      return questions;
    } catch (error) {
      return [];
    }
  },

  async updateAdmissionQuestions({ commit, state, getters }) {
    commit('enableLoader', true);

    const url = `admission/${getters.getCurrentAdmissionState.data.id}/questions`;
    const questionsToSend = getters.getQuestionnaireState.toSend;

    try {
      const updateQuestions = await checkinApi().post(url, questionsToSend);
      const questions = updateQuestions.data || [];
      commit('SET_ADMISSION_QUESTIONS', questions);
    } catch (error) {
      return [];
    }
    commit('enableLoader', false);
  },
};

export default admissionQuestionsActions;
